module.exports = __webpack_public_path__ + "static/media/10011.0fb71851.jpg";